export default __webpack_public_path__ + "media/images/illustration-placeholder-21fa6f58.svg";